module.exports = __webpack_public_path__ + "img/dashboard-statistics.014008ae.svg";